import { type Dispatch } from "@reduxjs/toolkit";
import {
  err as smtpErr,
  got as smtpGot,
  req as smtpReq,
  verifyErr,
  verifyGot,
  verifyReq,
} from "../slices/threatDefenceSmtpSettingsSlice";
import dataService from "features/Application/services/dataServices/typedDataService";
import accountsDataService from "features/Accounts/services/accountsDataService";
import { sendTransientNotification } from "features/Notifications/state/notificationsActions";
import { AlertTypes } from "enums";
import { type EmailSetting } from "features/Accounts/types";
import { getAxiosError } from "utils/axiosError";
import { castArray, head } from "lodash";

export const fetchThreatDefenceSmtpSettings = (accountId: number) => async (dispatch: Dispatch) => {
  dispatch(smtpReq());
  try {
    const response = await dataService.threatDefence.smtpSettings.getSmtpSettings(accountId);
    const settings = head(castArray(response));

    dispatch(smtpGot(settings));
  } catch (e) {
    dispatch(smtpErr(e.message));
  }
};

export const upsertThreatDefenceSmtpSettings =
  (accountId: number, settings: EmailSetting) => async (dispatch: Dispatch) => {
    dispatch(smtpReq());
    try {
      const { replyToEmail, ...settingsToSend } = settings;
      if (settings.id) {
        await dataService.threatDefence.smtpSettings.updateSmtpSettings(accountId, settingsToSend as EmailSetting);
      } else {
        await dataService.threatDefence.smtpSettings.createSmtpSettings(accountId, settingsToSend as EmailSetting);
      }
      dispatch(sendTransientNotification(AlertTypes.success));
      await fetchThreatDefenceSmtpSettings(accountId)(dispatch);
    } catch (e) {
      dispatch(smtpErr(e.message));
      dispatch(sendTransientNotification(AlertTypes.error));
    }
  };

export const deleteThreatDefenceSmtpSettings = (accountId: number) => async (dispatch: Dispatch) => {
  dispatch(smtpReq());
  try {
    await dataService.threatDefence.smtpSettings.deleteSmtpSettings(accountId);
    dispatch(sendTransientNotification(AlertTypes.success));
    await fetchThreatDefenceSmtpSettings(accountId)(dispatch);
  } catch (e) {
    dispatch(smtpErr(e.message));
    dispatch(sendTransientNotification(AlertTypes.error));
  }
};

export const verifyThreatDefenceSmtpSettings =
  (receiverValidationEmail: string, settings: EmailSetting) => async (dispatch: Dispatch) => {
    dispatch(verifyReq());
    try {
      await accountsDataService.verifyEmailSettings({ ...settings, receiverValidationEmail });
      dispatch(verifyGot());
    } catch (e) {
      const errorMessage: string = getAxiosError(e) || e?.response?.data;
      dispatch(verifyErr(errorMessage));
    }
  };
